<template lang="pug">
v-card(flat tile).d-flex.flex-column.scroll.fill-height
  .pt-2.px-4(v-if="item.serial")
    .text-caption.mr-2 Удостоверение №
    .text-body-2: strong {{ item.serial }} {{ item.number }}
  v-card-text.px-4.pt-2
    v-list-item.px-0.mb-4.mx-n1
      v-list-item-avatar.mr-2.my-0: v-icon(color="secondary" size="36") mdi-account-circle
      v-list-item-content.text-body-1: strong {{item.user.full_name}}

    .caption Программа:
    v-list-item.pl-2.mx-n2.mb-4(
      v-if="course"
      :to=`{
        name: 'CourseEnrollmentRecords',
        params: { enrollmentId: item.prior_record_id, id: course.id }
      }`
      target="_blank"
    )
      v-list-item-icon.mr-4
        v-img(
          style="border-radius: 8px"
          :src="require('@/assets/course-sample.png')"
          height="30"
          width="50"
          alt="Изображение курса"
        )
      v-list-item-content.text-body-2 {{ course.title }}
      v-list-item-action: v-icon(color="primary") mdi-chevron-right

    template(
      v-if="item.formed_at"
    )
      .caption.mb-2 Дата формирования:
      .black--text.text-body-2: strong {{item.formed_at | dp('d MMMM y HH:mm')}}

    v-expansion-panels.mt-8(
      v-if="item.download_request_snap"
      flat
    )
      v-expansion-panel
        v-expansion-panel-header.px-2.py-2
          div
            v-icon.mr-4(size="36" color="secondary") mdi-information-outline
            strong Информация о выдаче
        v-expansion-panel-content
          v-list-item.px-0
            v-list-item-content
              .caption Дата скачивания:
              .text-body-2: strong {{ item.downloaded_at | dp('d MMMM y HH:mm')}}
          v-list-item.px-0
            v-list-item-content.py-0
              .caption IP адрес:
              .text-body-2: strong {{ item.download_request_snap.ip }}
          v-list-item.px-0
            v-list-item-content.py-0
              .caption Город:
              .text-body-2: strong {{ item.download_request_snap.city }}
          v-list-item.px-0
            v-list-item-content.py-0
              .caption Провайдер:
              .text-body-2: strong {{ item.download_request_snap.org }}
          v-list-item.px-0
            v-list-item-content.py-0
              .caption Браузер:
              .text-body-2: strong {{ item.download_request_snap.browser }}
          v-list-item.px-0
            v-list-item-content.py-0
              .caption Операционная система:
              .text-body-2: strong {{ item.download_request_snap.os }}
    v-alert.mt-6(
      v-else-if="tab === 2"  outlined text type="warning"
    ) Обучающийся еще не скачал удостоверение
  v-card-actions.mt-auto
    v-btn(
      v-if="this.tab === 0"
      block color="primary" depressed
      @click="createDiploma"
    ) Сформировать
    .d-flex.flex-column.fill-width(v-else-if="tab === 1")
      div
        v-btn.mb-4(
          color="primary" depressed text
          :loadingPreview="loadingPreview"
          @click="openPreview"
        )
          v-icon(left) mdi-eye
          span Предпросмотр удостоверения
      v-btn(
        block color="primary" depressed
        @click="openFileSign"
      ) Подписать
    v-btn(
      v-else
      block color="primary" depressed
      :loading="loading"
      @click="download"
    ) Скачать удостоверение

  portal(
    v-if="tab === 1"
    to="sign.dialog" v-slot="{ close, attrs }"
  )
    v-card.sdo-card
      v-card-title Подпись удостоверения
      v-card-text
        v-btn.mb-4.px-5(
          color="primary" depressed text
          :loading="loadingPreview"
          @click="openPreview"
        )
          v-icon(left size="24") mdi-file-download
          span Удостоверение
        file-sign.mt-4(
          :files="attrs.document"
          hideLoaded
          :successCallback="signDocument"
        )
</template>
<script>
// import { getFileFromUrl } from '@/utils/base64';
import FileSign from '@/components/FileSignature/index.vue';

export default {
  components: {
    FileSign,
  },
  props: {
    item: { type: Object, required: true },
    tab: { type: Number, required: true },
  },

  data() {
    return {
      loading: false,
      loadingPreview: false,
      course: this.item.course || null,
      document: [],
    };
  },
  computed: {
    createMode() {
      return true;
    },
  },

  methods: {
    async download() {
      this.loading = true;
      const { data } = await this.$api.diploma.orgDownloadDiplomaPreview(this.item.id);
      this.loading = false;
      // const type = this.item.is_sign_required ? 'zip' : 'pdf';
      const type = 'pdf';
      const blob = new Blob([data], { type: `application/${type}` });
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = `Удостоверение.${type}`;
      link.click();
      link.remove();
    },
    async openPreview() {
      this.loadingPreview = true;
      const { data } = await this.$api.diploma.orgDownloadDiploma(this.item.id);
      this.loadingPreview = false;
      const blob = new Blob([data], { type: 'application/pdf' });
      const objectUrl = URL.createObjectURL(blob);
      window.open(objectUrl);
    },

    async openFileSign() {
      const { data } = await this.$api.diploma.orgDownloadDiploma(this.item.id);
      this.$modals.show('dialog-portal', {
        inputValue: 'sign',
        document: [{ is: data, originalName: `Удостоверение № ${this.item.serial} ${this.item.number}` }],
      });
    },
    async signDocument([value]) {
      await value.validate();
      const {
        hash,
        signature,
        signData: {
          commonName, lastName, street, subjectFederation, inn, linn, ogrn, ogrnip, snils, email,
          organization, country, locality, orgUnit, firstMiddleName,
          serialNumber, validFromDate, validToDate, issuerName, title,
        },
      } = value;
      const payload = {
        hash,
        position: title,
        sign_hash: signature,
        common_name: commonName,
        issuer_name: `${lastName} ${firstMiddleName}`,
        serial_number: serialNumber,
        valid_from_at: validFromDate,
        valid_to_at: validToDate,
        last_name: lastName,
        first_middle_name: firstMiddleName,
        title,
        org_unit: orgUnit,
        organization,
        locality,
        country,
        street,
        subject_federation: subjectFederation,
        inn,
        linn,
        ogrn,
        ogrnip,
        snils,
        email,
        sign_issuer_name: issuerName,
      };
      await this.$rHandler(
        this.$api.diploma.signDiploma(this.item.id, payload),
        () => {
          this.$modals.close();
          this.$emit('unSelect');
          this.$toasted.success('Успешно');
        },
      );
    },

    createDiploma() {
      this.$modals.show('form-controller', {
        title: 'Формирование удостоверения',
        method: ({ data }) => {
          const payload = {
            ...data,
            prior_record_user_ids: [this.item.id],
            exclude_prior_record_user_ids: [],
          };
          return this.$api.diploma.createDiplomas(payload).then(() => {
            this.$modals.close();
            this.$emit('unSelect');
            this.$toasted.success('Успешно');
          });
        },
        fields: [{
          component: 'v-text-field',
          text: 'Введите серийный номер',
          value: 'serial',
          rules: 'required|length:4',
          component_attrs: {
            counter: 4,
            filled: true,
            rounded: true,
          },
        }],
      });
    },
  },
};
</script>
